import { useCallback, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { SyncKnowledgeBaseZendeskHelpCenterForm } from './SyncKnowledgeBaseZendeskHelpCenterForm';
import { IntegrationSyncIcon } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/CurrentKnowledgeBaseIcons/CurrentKnowledgeBaseIcons';
import { INTEGRATION_NAMES_MAP } from 'src/utils/fileUtils';
import { SyncKnowledgeBaseScheduleForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/SyncKnowledgeBaseIntegrationModal/SyncKnowledgeBaseScheduleForm';
import { API_VERSION } from 'src/constants/api-routes';
import type { TreeNode } from 'src/utils/fileUtils';
import { getApiVersion } from 'src/utils/apiVersion';

export const SyncKnowledgeBaseIntegrationModal = ({
  disabled = false,
  item,
}: {
  disabled?: boolean;
  item: TreeNode;
}) => {
  const [open, setOpen] = useState(false);

  const close = () => {
    setOpen(false);
  };

  const renderForm = useCallback(() => {
    switch (item.data.type) {
      case 'zendesk_helpcenter':
        return <SyncKnowledgeBaseZendeskHelpCenterForm close={close} item={item} />;
      case 'zendesk_tickets':
        return (
          <SyncKnowledgeBaseScheduleForm close={close} item={item} formId="sync-new-zendesk-form" />
        );
      case 'freshdesk_tickets':
        return (
          <SyncKnowledgeBaseScheduleForm
            close={close}
            item={item}
            formId="sync-new-freshdesk-form"
          />
        );
      case 'web_scrapper':
        return (
          <SyncKnowledgeBaseScheduleForm
            close={close}
            item={item}
            formId="sync-new-website-form"
            weeklyOnly={getApiVersion() === API_VERSION.V2}
          />
        );
    }
  }, [item]);

  return (
    <Dialog onOpenChange={setOpen} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        <button
          className={clsx(
            disabled && 'pointer-events-none opacity-20',
            'flex gap-2 opacity-30 hover:opacity-100 transition',
          )}
        >
          <IntegrationSyncIcon />
        </button>
      </DialogTrigger>
      <DialogContent closeButtonHidden>
        <DialogHeader>
          <DialogTitle>{INTEGRATION_NAMES_MAP[item.data.type]} Synchronization</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">{renderForm()}</div>
      </DialogContent>
    </Dialog>
  );
};
